const Flickity = require('flickity');

export default () => {

    const slider = document.querySelector('[data-hero-slider]');

    function updateHeroCopyHeights()
    {
        const titles = document.querySelectorAll('.hero__slide__copy');
        const videoButtons = document.querySelectorAll('[data-hero-video]');
        let height = 0;
        for (const t of titles) {
            t.style.removeProperty('height');
            const h = t.getBoundingClientRect().height;
            if (h > height) {
                height = h;
            }
        }


        if (window.innerWidth <= 768) {
            for (const t of titles) {
                t.style.height = height + 'px';
                const slide = t.parentNode;
                const videoButton = slide.querySelector('[data-hero-video]');
                if (videoButton) {
                    videoButton.style.minHeight = (slide.getBoundingClientRect().height - height) + 'px';
                }
            }
        } else {
            for (const t of titles) {
                t.style.removeProperty('height');
            }
        }
    }

    if (slider) {
        if (slider.children.length > 1) {
            const flickity = new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
                pageDots: true,
                autoPlay: false
            });
        }

        // updateHeroCopyHeights();
        // window.addEventListener('resize', updateHeroCopyHeights);
    }

}
